module.exports = __webpack_public_path__ + "img/canvasMenu10_paste.20e1da5b.svg";